import { apicall } from "../../services/api";
import { GET_COLLECTIONS, ERR_COLLECTION, LOADING_COLLECTIONS } from "../actions/actionTypes";

export const getAllCollections = () => async (dispatch) => {
	try {
		const res = await apicall(`collections`, "get");
		if (res.data.msg === "No data found.") {
			dispatch({
				type: GET_COLLECTIONS,
				payload: res.data.data,
			});
		} else {
			dispatch({
				type: GET_COLLECTIONS,
				payload: res.data,
			});
		}
	} catch (err) {
		dispatch({
			type: ERR_COLLECTION,
			payload: { msg: err.response.msg, status: err.response.status },
		});
	}
};
export const showLoading = (flag) => async (dispatch) => {
	dispatch({
		type: LOADING_COLLECTIONS,
		payload: flag
	});
}